import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'react-datepicker/dist/react-datepicker.css';

// import { Auth0Provider } from '@auth0/auth0-react';

// import { App } from './App';

// const domain = process.env.REACT_APP_AUTH0_DOMAIN ?? '';
// const clientId = process.env.REACT_APP_AUTH0_CLIENT ?? '';
// const audience = process.env.REACT_APP_AUTH0_AUDIENCE ?? '';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

// const onRedirectCallback = (appState: any) => {
// 	window.location.replace(appState?.returnTo || window.location.href);
// };

// Redirect Component
const LegacyRedirect = () => {
	useEffect(() => {
		window.location.href = 'https://hub.service.ly/'; // Replace with your new platform URL
	}, []);

	return null; // No need to render anything
};

root.render(
	<React.StrictMode>
		{/* redirect to current platform */}
		<LegacyRedirect />

		{/* LEGACY APPLICATION */}
		{/* <Auth0Provider
			domain={domain}
			clientId={clientId}
			onRedirectCallback={onRedirectCallback}
			authorizationParams={{
				redirect_uri: window.location.href,
				audience,
			}}
			cacheLocation={'localstorage'}
			useRefreshTokens={true}
		>
			<App />
		</Auth0Provider> */}
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
